import { render, staticRenderFns } from "./flowFrom.vue?vue&type=template&id=ff1985a8&scoped=true"
import script from "./flowFrom.vue?vue&type=script&lang=js"
export * from "./flowFrom.vue?vue&type=script&lang=js"
import style0 from "./flowFrom.vue?vue&type=style&index=0&id=ff1985a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1985a8",
  null
  
)

export default component.exports